import React, { Component } from 'react';
import './style.css';
import img from './img.png';
import { lory } from 'lory.js';

export class Clients extends Component {
    domSlider;
    sliderIsFilled = false;
    slider;
    slidesArray = [];
    dots = [];

    componentDidUpdate() {
        if (!this.sliderIsFilled && typeof this.props.content !== 'undefined' && typeof this.props.content.data.body[0] !== 'undefined') {
            this.initSlider();
        }
        if (this._container.classList.contains("loading")) {
            this._container.classList.remove("loading");
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.lang !== nextProps.lang) {
            this.sliderIsFilled = false;
            this.slidesArray = [];
            this.slider.destroy();
            for (var i = 0, len = this.dots.length; i <= len - 1; i++) {
                this.dots[i].classList.remove('active');
            }
            this.dots[0].classList.add('active');
        }
    }

    initSlider() {
        this.domSlider.addEventListener('after.lory.init', e => { this.handleDotEvent(e) });
        this.domSlider.addEventListener('after.lory.slide', e => { this.handleDotEvent(e) });
        this.domSlider.addEventListener('on.lory.resize', e => { this.handleDotEvent(e) });

        this.slider = lory(this.domSlider, {
            infinite: 1,
            enableMouseEvents: 1
        });
        this.sliderIsFilled = true;
    }

    handleDotEvent(e) {
        if (e.type === 'after.lory.slide') {
            for (var i = 0, len = this.dots.length; i <= len - 1; i++) {
                this.dots[i].classList.remove('active');
            }
            this.dots[e.detail.currentSlide - 1].classList.add('active');
        }
        if (e.type === 'on.lory.resize') {
            for (var i = 0, len = this.dots.length; i <= len - 1; i++) {
                this.dots[i].classList.remove('active');
            }
            this.dots[0].classList.add('active');
        }
    }

    render() {
        let imagesItems;
        let slides;
        let slideFillIndex;
        let bullets;
        let title;

        if (!this.sliderIsFilled && typeof this.props.content !== 'undefined' && typeof this.props.content.data.body[0] !== 'undefined') {
            imagesItems = this.props.content.data.body[0].items;
            slideFillIndex = 0;
            imagesItems.forEach((e, i) => {
                if ((i / 12) % 1 === 0) {
                    slideFillIndex++;
                    this.slidesArray.push([])
                }
                this.slidesArray[slideFillIndex - 1].push(e);
            }, this);
        }

        if (typeof this.props.content != 'undefined') {
            slides = this.slidesArray.map((e, i) => {
                return (
                    <li className="js_slide slide"
                        key={i}
                    >
                        <ul className="clients-list">
                            {e.map((e, i) => {
                                return (
                                    <li className="clients-list__item"
                                        key={i}
                                    >
                                        <img src={e.image.url} alt="client logo" />
                                    </li>
                                )
                            })}
                        </ul>
                    </li>
                )
            });

            bullets = this.slidesArray.map((e, i) => {
                return (
                    <li key={i}
                        ref={e => { this.dots[i] = e }}
                        className={i === 0 ? 'active' : ''}
                        onClick={e => {
                            this.slider.slideTo(Array.prototype.indexOf.call(this.dots, e.target));
                        }}
                    ></li>
                )
            });

            title = this.props.content.data.title[0].text;
        }

        return (
            <section className="site-section clients loading" ref={(el) => { this._container = el }}>
                <span className="decoration-line to-animate"></span>
                <h2 className="section-title">{title}</h2>
                <div className="slider js_slider"
                    ref={e => { this.domSlider = e }}
                >
                    <div className="frame js_frame">
                        <ul className="slides js_slides">
                            {slides}
                        </ul>
                    </div>
                    <ul className="js_dots dots">
                        {bullets}
                    </ul>
                </div>
            </section>
        );
    }
}

export default Clients;


// WEBPACK FOOTER //
// ./src/components/clients/index.js